import { render, staticRenderFns } from "./AkademieMain.vue?vue&type=template&id=1380460d&scoped=true"
import script from "./AkademieMain.vue?vue&type=script&lang=js"
export * from "./AkademieMain.vue?vue&type=script&lang=js"
import style0 from "./AkademieMain.vue?vue&type=style&index=0&id=1380460d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1380460d",
  null
  
)

export default component.exports